import React, { useState, useEffect } from 'react';
import { Button, Spin, Tooltip } from 'antd';
import { LoadingOutlined, ExclamationOutlined, ArrowDownOutlined } from '@ant-design/icons';
import Recompress from '../Recompress';
import FileProgress from './FileProgress';
import Analytics from '../../services/Analytics';

const antIcon = <LoadingOutlined spin />;
const questionCircle = (
	<Tooltip
		title="Increase compresssion. Select high or extreme from the dropdown."
		placement="left"
	>
		<Button shape="circle" icon={<ExclamationOutlined />} />
	</Tooltip>);

const RowActions = props => {
	const [busy, setBusy] = useState(false);
	const [, updateState] = React.useState();
	const forceUpdate = React.useCallback(() => { return updateState({}); }, []);
	const { file } = props;
	const disabled = file.percentageCompression <= 0;

	function onUpdate() { forceUpdate(); }

	async function onCompressionModeChanged(mode) {
		setBusy(true);
		await file.recompress(mode);
		setBusy(false);
	}

	const fileProgress = <FileProgress file={file} />;
	const downloadBtn = (<Button
		shape="circle"
		icon={<ArrowDownOutlined />}
		key="btn-download"
		onClick={() => {
			Analytics.onFileDownload();
			return window.open(file.url, '_self');
		}}
		disabled={disabled}
	/>);
	const recompress =
		(<Recompress
			file={file}
			compressionMode={file.compressionMode.name}
			onCompressionModeChanged={onCompressionModeChanged}
		/>);
	let actions;
	if (file.isCompressed === true) actions = [downloadBtn];
	// if (file.isCompressed === true) actions = [compare, downloadBtn];
	// override download button
	if (file.percentageCompression <= 0) actions = questionCircle;
	useEffect(() => {
		file.subscribe(onUpdate);
		return () => {
			file.unsubscribe(onUpdate);
		};
	}, []);
	if (file.url === undefined) return fileProgress;
	return (
		<Spin wrapperClassName="spin-wrapper-row-actions" spinning={busy} indicator={antIcon}>
			{recompress}
			{actions}
		</Spin>
	);
};

// onCompareButtonClick = () => {
	// 	const { file, onCompareButtonClick } = this.props;
	// 	onCompareButtonClick(file);
	// }
	// const compare =
	// (<Button
	// 	shape="circle"
	// 	onClick={this.onCompareButtonClick}
	// 	icon="scan"
	// 	key="btn-compare"
	// 	className="compare-button"
	// 	disabled={disabled}
	// />
	// );

export default RowActions;



// WEBPACK FOOTER //
// ./src/components/file-table/RowActions.js